import styled from "styled-components";

export const TableStyle = styled.div`
  .table-area {
    width: 100%;
    background-color: var(--branco) !important;
    
  }

  .table {
    color: var(--preto-primario) !important;
    tbody {
      
      tr {
        
        td {
          color: var(--preto-primario) !important;
          border-bottom: none !important;
        }
      }

      .action-column {
        text-align: center;

        #delete-icon {
          color: var(--vermelho-perigo);
          &:hover {
            color: var(--verde-primario);
            cursor: pointer;
          }
        }

        svg {
          font-size: 24px;
          &:hover {
            color: var(--verde-primario);
            cursor: pointer;
          }
        }
      }
    }
  }

  @media screen and (max-width: 800px) {
    .table-area {
      overflow-y: scroll !important;
    }
  }
`;
